export const Mapping = {
  Prelem_001: "WebsiteIntroduction", //Enabled
  Prelem_002: "ProductSummaryViaImage", //Enabled
  Prelem_097: "ProductSummaryViaVideo",
  Prelem_004: "Sponsor", //Enabled
  Prelem_005: "Quote", //Enabled
  Prelem_006: "ArticleDetail", //Enabled
  Prelem_007: "ContactUs", //Enabled
  Prelem_008: "AnimationOnPageScroll", //Enabled
  Prelem_009: "WebsiteIntroduction2", //Enabled
  Prelem_010: "dynamicTweets",
  Prelem_011: "SignBoard", //Enabled
  Prelem_012: "Testimonial",
  Prelem_013: "ServiceCard", //Enabled
  Prelem_014: "ProductSummaryViaVideo2", //Enabled
  Prelem_016: "ServiceShowcase", //Enabled
  Prelem_017: "ProductSummaryViaImage2", //Enabled
  Prelem_018: "ExpertiseShowcase",
  Prelem_019: "FullWidthImage", //Enabled
  Prelem_020: "FullWidthVideo", //Enabled
  Prelem_021: "ImageCarousel1", //Enabled
  Prelem_022: "Banner1", //Enabled
  Prelem_023: "Description", //Enabled
  Prelem_024: "Banner2", //Enabled
  Prelem_025: "Banner3", //Enabled
  Prelem_026: "FullWidthText", //Enabled
  Prelem_0160: "FullWidthTextAndCTA", //Enabled
  Prelem_027: "ImageCards", //Enabled
  Prelem_028: "VideoBanner1", //Enabled
  Prelem_029: "FullWidthTextWithImage", //Enabled
  Prelem_0115: "ServiceCard1", //Enabled
  Prelem_0114: "ServiceCard2", //Enabled
  Prelem_0116: "ServiceCard3",
  Prelem_033: "FeatureBox1",
  Prelem_034: "FeatureBox2",
  Prelem_0112: "ServiceCard4",
  Prelem_037: "ServiceCard5", //Enabled
  Prelem_038: "Services1", //Enabled
  Prelem_0159: "Services3",
  Prelem_0117: "Services2", //Enabled
  Prelem_040: "Gallery1",
  Prelem_041: "MultiSlot",
  Prelem_0113: "ServiceCard6",
  Prelem_043: "VideoBanner2", //Enabled
  Prelem_045: "AboutUs2", //Enabled
  Prelem_0110: "Faq1", //Enabled
  Prelem_047: "Awards1", //Enabled
  Prelem_048: "DynamicPrelem",
  Prelem_050: "CustomerTestimonial2",
  Prelem_052: "ImageVideoCarousel1",
  Prelem_053: "BlogTiles", //Enabled
  Prelem_054: "AboutUsThree", //Enabled
  Prelem_055: "ParagraphWithHeadlineAndCTA",
  Prelem_056: "ParagraphWithHeadline", //Enabled
  Prelem_057: "Banner4", //Enabled
  Prelem_058: "LeftAlignParagraphWithHeadline", //Enabled
  Prelem_059: "WebsiteSummaryWithSubHeading",
  Prelem_060: "WebsiteSummaryWithSubHeading2",
  Prelem_061: "ProductSummary3", //Enabled
  Prelem_062: "TeamMembers",
  Prelem_063: "Statistics", //Enabled
  Prelem_064: "AboutUsFourWithSubHeading", //Enabled
  Prelem_0118: "ServiceShowcase2", //Enabled
  Prelem_066: "EcomProduct",
  Prelem_067: "ServiceCard7",
  Prelem_0156: "ServiceCard8",
  Prelem_0161: "TeamMembers2",
  Prelem_068: "ContentDisplayWithCategories",
  Prelem_069: "FeatureTiles", //Enabled
  Prelem_070: "CounterNumberShowcase", //Enabled
  Prelem_071: "MultiSlot2", //Enabled
  Prelem_072: "Ecommerce3Slot1", //Enabled
  Prelem_073: "Ecommerce3Slot2",
  Prelem_074: "DynamicEcommercePrelem",
  Prelem_075: "Banner5", //Enabled
  Prelem_076: "ContactUsForm",
  Prelem_077: "DynamicPrelemOne",
  Prelem_078: "LearningList",
  Prelem_079: "Banner6", //Enabled
  Prelem_080: "DynamicPrelemWithCarousel2", //Enabled
  Prelem_081: "DynamicPrelemWithCarousel1", //Enabled
  Prelem_083: "FullWidthBanner3",
  Prelem_084: "WebsiteIntroduction4",
  Prelem_085: "InfoBox",
  Prelem_090: "ZaggEcommerce",
  Prelem_091: "RegisteredProduct",
  Prelem_092: "ProductRegistration",
  Prelem_0100: "MyStory",
  Prelem_0101: "CategoryBox",
  Prelem_0102: "FeatureInfoCards",
  Prelem_105: "FormCreator", // Enabled
  // Prelem_0110: "SchemaAuthoringServiceCard",
  Prelem_3700: "LivestreamFeed",
  Prelem_0178: "HeroBannerWithBGVideo",
  Prelem_0150: "Gallery2", // Enabled
  Prelem_0151: "ImageCarousel2",
  Prelem_0152: "ImageAndVideoGalleryNew", // Enabled
  Prelem_0153: "ImageVideoCarousel1New", // Enabled
  Prelem_0162: "StaticForm",
  Prelem_0155: "Faq2",
  Prelem_0154: "Partner",
  Prelem_0157: "BrandAlliance", //Enabled
  Prelem_0158: "BannerWithCard", //Enabled
  Prelem_0163: "Accolade1", // Enabled
  Prelem_0164: "Accolade2", // Enabled
  Prelem_0165: "FullWidthVideo2", //Enabled
  Prelem_0166: "BannerWithCTA",
  //Hocky Victory prelems
  Prelem_0175: "DynamicPartnerBenefits", //table prelem
  Prelem_0167: "HeroWithTwoImages", //Enabled
  Prelem_0168: "BannerBGWithDescription", //Enabled
  Prelem_0169: "HeroFeatureShowcase", //Enabled
  Prelem_0171: "HeroFeatureShowcase2", //Enabled
  Prelem_0170: "HeroFeatureShowcase3", //Enabled
  Prelem_0174: "Sponsor2", //Enabled
  Prelem_0176: "TabsWithDescription", //Enabled
  Prelem_0177: "BgImageWithSponsors", //Enabled
  Prelem_0173: "TeamMembers3",
  Prelem_0179: "TeamMembers4",
  Prelem_0172: "ServiceCard9",
  Prelem_0181: "DynamicPrelemTwo",
  Prelem_0195: "DynamicPrelemWithGrid",
  Prelem_0197: "DynamicPrelemWithNewsGrid",

  //ContentType
  ContentType_01: "Article",
  ContentType_02: "VideoLandingPage",
  ContentType_03: "Quiz",
  ContentType_04: "Poll",
  ContentType_05: "EventLandingPage",
  profile: "PlayerDetail",
  playeranalysis: "PlayerAnalysis", //Did this for demo where we filter videos based on tags.
  eventcf: "EventCFLandingPage",
  //Newly added prelems for Hocky Victory
  Prelem_0182: "ContentGrid",
  Prelem_0183: "HeroBannerWithDetails",
  Prelem_0184: "DetailParagraph",
  Prelem_0185: "ComboCards",
  Prelem_0186: "HeroTitle",
  Prelem_0187: "DetailParagraphWithImage",
  Prelem_0188: "FeatureCard",
  Prelem_0189: "FeatureBox3",
  Prelem_0190: "FeatureBox4",
  Prelem_0191: "HeroBannerWithCTA",
  Prelem_0192: "DescriptionWithCTA",
  Prelem_0194: "CardWithDescription1",
  Prelem_0193: "CardWithDescription",
  Prelem_0196: "PlayerSquard",
  Prelem_0198: "MemberShipBanner",
  Prelem_0199: "MemberShipCard",
  Prelem_0200: "CuratedHeroBannerCarousel",
  Prelem_0201: "DynamicHeroBannerCarousel",
  Prelem_0202: "DynamicContentSlider",
  /*
   PRELEMS FOR DPWORLDS TOUR
   */
  Prelem_0207: "DynamicTourScheduleCarousel",
  Prelem_0208: "DynamicLeaderBoardCarousel",
  Prelem_0209: "DynamicStatisticsCarousel",
  Prelem_0204: "LifeonTourPodcast",
  Prelem_0210: "HeroContentBanner",
  Prelem_0206: "FeaturedVideosCarousel",
  Prelem_0211: "Schedule",
  Prelem_0212: "FeatureBannerSlider",
  Prelem_0213: "MediaSpotlight",
  Prelem_0214: "TournamentShowcase",
  Prelem_0233: "NewsGrid",
  Prelem_0306: "ServiceCardJumpIn",
  Prelem_0307: "PageHeroBanner",
  Prelem_0314: "ServiceCardFeatureGrid",
  Prelem_0311: "HVHeroBanner",
  Prelem_0315: "StatCounterBand",
  Prelem_0316: "AthleteSpotlight",
};
